import React from 'react'
import {reset} from '../../store'
import SimpleModalComponent from '../../shared/modal/SimpleModalComponent'
import PlayersComponent from '../../game/players/PlayersComponent'
import StatsComponent from '../../game/stats/components/StatsComponent'
import ConnectedComponent from '../../shared/connecter/ConnectedComponent'
import SettingsComponent from '../dialogs/SettingsComponent'

import AppBar from 'material-ui/AppBar'
import IconButton from 'material-ui/IconButton'
// import IconMenu from 'material-ui/IconMenu'
// import MenuItem from 'material-ui/MenuItem'

import SettingsIcon from 'material-ui/svg-icons/action/settings'
//import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import FullScreenIcon from 'material-ui/svg-icons/navigation/fullscreen'
import ChartIcon from 'material-ui/svg-icons/editor/show-chart'
import PeopleIcon from 'material-ui/svg-icons/social/people'
import FlatButton from 'material-ui/FlatButton'


class ConfirmResetModal extends React.Component {
    reset = () => {
        reset()
        this.props.close()
    }

    render() {
        return (
            <div className="text-center" style={{padding: '20px'}}>
                <button className="btn btn-default" onClick={this.props.close}>Non</button>
                &nbsp;&nbsp;
                <button className="btn btn-info" onClick={this.reset}>Oui</button>
            </div>
        )
    }

}

function toogleFullScren() {
    if (!document.fullscreenElement &&    // alternative standard method
        !document.mozFullScreenElement && !document.webkitFullscreenElement) {  // current working methods
        if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
    } else {
        if (document.cancelFullScreen) {
            document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
        }
    }
}

export class HeaderComponent extends React.Component {

    constructor() {
        super()
        this.state = {
            params: false,
            reset: false
        }
        this.modal = null
    }

    params = () => {
        //const content = <ParamsModal close={e=>this.toggleParams(false)} />
        //return this.state.params ? <SimpleModalComponent modalStyle={{width:'80%'}} title={'Paramètres'} content={content} close={e=>this.toggleParams(false)} /> : null
    }

    toggleParams = (status) => {
        this.setState({
            params: typeof status !== 'undefined' ? status : !this.state.params
        })
    }

    fullscreen = () => {
        //const elem = document.body;
        toogleFullScren()
    }

    confirm = () => {
        const content = <ConfirmResetModal close={e => this.toggleReset(false)}/>
        return this.state.reset ? <SimpleModalComponent title={'Nouvelle Partie'} content={content}
                                                        close={e => this.toggleReset(false)}/> : null
    }

    toggleReset = (status) => {
        this.setState({
            reset: typeof status !== 'undefined' ? status : !this.state.params
        })
    }

    render() {
        return (
            <div className="app-header">
                {this.params()}
                {this.confirm()}
                <nav className="navbar navbar-inverse navbar-fixed-top">
                    <div className="" style={{padding: '12px 10px'}}>
                        <div className="pull-left">
                            <button className="btn btn-header" onClick={e => this.toggleReset()}>Nouvelle partie
                            </button>
                        </div>
                        <div className="text-right">
                            <button className="btn  btn-header" onClick={e => this.toggleParams()}>
                                <i className="fa fa-cog"/>
                            </button>
                            &nbsp;&nbsp;
                            <button className="btn  btn-header" onClick={e => this.fullscreen()}>
                                <i className="fa fa-arrows-alt"/>
                            </button>
                        </div>
                    </div>
                </nav>
            </div>)
    }
}


//<MenuItem primaryText={'Orientation'} leftIcon={<ScreenRotationIcon />} onClick={this.toggleOrientation} />


class RightMenu extends ConnectedComponent {
    constructor() {
        super()
        this.subscribe('settings')
    }

    reset() {
        reset()
    }

    layout = (_layout) => {
        this.store.settings.set('layout', _layout)
    }

    toggleOrientation = () => {
        var current = this.store.settings.get('layout')
        this.layout(current === 'vertical' ? 'horizontal' : 'vertical')
    }

    handleParamsDialog = (type) => {
        this.props.openParams(type)
    }

    render() {
        const props = {...this.props}
        delete props['openParams']
        return (
            <div>
                <IconButton onTouchTap={toogleFullScren}><FullScreenIcon color="#FFF" /></IconButton>
                <IconButton onTouchTap={() => this.handleParamsDialog('playersModal')} ><PeopleIcon color="#FFF"/></IconButton>
                <IconButton onTouchTap={() => this.handleParamsDialog('statsModal')} ><ChartIcon color="#FFF" /></IconButton>
                <IconButton onTouchTap={this.props.openSecondary} ><SettingsIcon  color="#FFF" /></IconButton>
            </div>
        )
    }

}


class AppHeaderComponent extends ConnectedComponent {
    constructor() {
        super()
        this.subscribe('settings')
    }

    openModal = (type) => {
        this.store.settings.set('modal', type)
    };

    closeModal = () => {
        this.store.settings.set('modal', null)
    };

    render() {
        const actions = [
            <FlatButton
                label="Fermer"
                keyboardFocused={true}
                onTouchTap={() => this.closeModal('playersModal')}
            />,
        ];
        const rightMenu = <RightMenu openSecondary={this.props.openSecondary} openParams={this.openModal}/>
        return (

            <AppBar title="Yamsy" iconElementRight={rightMenu} onLeftIconButtonTouchTap={this.props.toggleMenu}>
                <SettingsComponent
                    actions={actions}
                    modal={false}
                    open={!!this.store.settings.get('modal')}
                    onRequestClose={() => this.closeModal('')}
                    autoScrollBodyContent={true}
                    repositionOnUpdate={true}
                >
                    {
                        this.store.settings.get('modal') === 'playersModal' ?
                            <PlayersComponent close={() => this.closeModal('')}/> :
                            <StatsComponent button={true} close={() => this.closeModal('')}/>
                    }
                </SettingsComponent>
            </AppBar>
        )
    }
}

export default AppHeaderComponent;


// WEBPACK FOOTER //
// ./src/layout/components/HeaderComponent.jsx